import { render, staticRenderFns } from "./SelectArtist.vue?vue&type=template&id=f0456594&scoped=true&"
import script from "./SelectArtist.vue?vue&type=script&lang=js&"
export * from "./SelectArtist.vue?vue&type=script&lang=js&"
import style0 from "./SelectArtist.vue?vue&type=style&index=0&id=f0456594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0456594",
  null
  
)

export default component.exports